// extracted by mini-css-extract-plugin
export default {"root":"PlanRow-root__oluf"};